import { WorkflowStatusName } from "./WorkflowStatusName";

// WF状態
export class WorkflowStatus {

  public status: WorkflowStatusName;
  public order: number;
  public limitDate: Date;

  clone(): WorkflowStatus {
    const newObj = new WorkflowStatus();
    newObj.status = this.status;
    newObj.order = this.order;
    newObj.limitDate = this.limitDate;

    return newObj;
  }
}
